import React from 'react';
import { useSelector } from 'react-redux';

import { ProjectMemberStorageErrorBanner } from '@neptune/project-ui';
import { useObtainOwnerEmails } from '@neptune/shared/organization-business-logic';

import { getContextOrganization } from 'state/selectors-global';

export const ProjectMemberStorageErrorBannerContainer: React.FC = () => {
  const organizationContext = useSelector(getContextOrganization);
  const adminEmails = useObtainOwnerEmails(organizationContext?.name);

  return <ProjectMemberStorageErrorBanner adminEmails={adminEmails} />;
};
